import { Paper } from '@mui/material';

export function EditProjectPaper({ children }: { children: React.ReactNode }) {
  return (
    <Paper
      elevation={3}
      sx={{
        mt: 6,
        p: 3,
        borderRadius: '28px',
        maxWidth: 1000,
        mx: 'auto',
      }}
    >
      {children}
    </Paper>
  );
}
